module.exports = __webpack_public_path__ + "media/images/dashboards/performance-03795c9404d6d24e7b0c65c23b1f6e87.png";